import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceEditAllocationNotificationState = createStateReducer(initialState, {
  [events.editAllocationSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editAllocation",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.editAllocationFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editAllocation",
        flags: [],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceEditAllocationNotificationState };
